import { useLang } from "@/i18n/LanguageContext";

export default function TransformationCard({ item, className = "" }) {
  const { t } = useLang();
  return (
    <figure
      className={`mb-6 break-inside-avoid rounded-2xl overflow-hidden bg-white border border-border shadow-sm transition-shadow hover:shadow-md ${className}`}
      data-testid={`transformation-${item.id}`}
    >
      {item.image ? (
        <img src={item.image} alt={`${item.label} transformation`} className="w-full aspect-[4/3] object-cover" loading="lazy" />
      ) : (
        <div className="grid grid-cols-2">
          <div className="relative">
            <img src={item.before} alt={`${item.label} before`} className={`w-full ${item.aspect || "aspect-[3/2]"} object-cover`} loading="lazy" />
            <span className="absolute top-3 left-3 text-xs font-bold uppercase tracking-wider bg-secondary text-white rounded-full px-3 py-1 shadow">{t("tcard.before")}</span>
          </div>
          <div className="relative border-l-2 border-white">
            <img src={item.after} alt={`${item.label} after`} className={`w-full ${item.aspect || "aspect-[3/2]"} object-cover`} loading="lazy" />
            <span className="absolute top-3 right-3 text-xs font-bold uppercase tracking-wider bg-accent text-white rounded-full px-3 py-1 shadow">{t("tcard.after")}</span>
          </div>
        </div>
      )}
      <figcaption className="px-4 py-3 flex items-center justify-between gap-2">
        <div className="min-w-0">
          <p className="font-heading font-bold text-sm leading-tight">{item.label}</p>
          {item.clinic && <p className="text-xs text-muted-foreground truncate">{item.clinic}</p>}
        </div>
        <span className="text-xs text-primary font-semibold shrink-0">{t("tcard.realPatient")}</span>
      </figcaption>
    </figure>
  );
}
